import { render, staticRenderFns } from "./ed-pdf-rotate-pages.vue?vue&type=template&id=65b40f15&"
import script from "./ed-pdf-rotate-pages.ts?vue&type=script&lang=ts&"
export * from "./ed-pdf-rotate-pages.ts?vue&type=script&lang=ts&"
import style0 from "./ed-pdf-rotate-pages.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports